import { OperateDocumentEnum, OperateBoardEnum, ContainerType, Drag, ZOOM_FACTORS } from '../common/Constant';
import GesturePlugin from '../plugin/GesturePlugin';
import DocModuler from '../DocModuler';

/**
 * 缩放API 代理方法
 *
 * @export
 * @class ZoomApi
 */
export default class ZoomApi {
  constructor(container, store) {
    this.container = container;
    this.store = store;
    this.doodleType = null;
    this.gesture = new GesturePlugin(store);
    this.e = {
      ZoomIn: e => {
        const { xPos: x, yPos: y } = e;
        let currentFactor = this.store.getKV('scaleFactor');
        let factor = this.e.nextValue(DocModuler.zoomFactors, currentFactor);
        this.store.setKV('scaleFactor', factor);

        if (this.container.type === ContainerType.DOCUMENT) {
          // this.container.operateDocument(OperateDocumentEnum.Scale, factor, x, y)
        }

        this.container.operateDoodle(OperateBoardEnum.Scale, factor, x, y);
        this.gesture.zoom(factor, x, y);
      },
      ZoomOut: e => {
        const { xPos: x, yPos: y } = e;

        let currentFactor = this.store.getKV('scaleFactor');
        let factor = this.e.prevValue(DocModuler.zoomFactors, currentFactor);
        this.store.setKV('scaleFactor', factor);

        if (this.container.type === ContainerType.DOCUMENT) {
          // this.container.operateDocument(OperateDocumentEnum.Scale, factor, x, y)
        }

        this.container.operateDoodle(OperateBoardEnum.Scale, factor, x, y);
        this.gesture.zoom(factor, x, y);
      },
      nextValue: (arr, currentValue) => {
        let i = arr.indexOf(currentValue);
        if (arr.indexOf(currentValue) < 0) {
          i = arr.indexOf(1);
        }

        i += 1;
        i = Math.max(Math.min(i, arr.length - 1), 0);
        return arr[i];
      },
      prevValue: (arr, currentValue) => {
        let i = arr.indexOf(currentValue);
        if (arr.indexOf(currentValue) < 0) {
          i = arr.indexOf(1);
        }

        i -= 1;
        i = Math.max(Math.min(i, arr.length - 1), 0);
        return arr[i];
      }
    };

    this.startZoomMode = false;
  }

  /**
   * 放大
   *
   * @memberof DocModuler
   */
  zoomIn() {
    if (!this.startZoomMode) {
      this.zoomStart();
    }

    // this.gesture.off('tap', this.e.ZoomOut);
    // this.gesture.off('tap', this.e.ZoomIn);
    // this.gesture.on('tap', this.e.ZoomIn);

    let dragElId = this.store.getKV('dragId');
    let dragEl = document.getElementById(dragElId);
    dragEl.style.transformOrigin = 'center';

    let currentFactor = this.store.getKV('scaleFactor');
    let factor = this.e.nextValue(DocModuler.zoomFactors, currentFactor);
    this.store.setKV('scaleFactor', factor);
    this.gesture.zoom(factor, 0, 0);
  }

  /**
   * 缩小
   *
   * @memberof DocModuler
   */
  zoomOut() {
    if (!this.startZoomMode) {
      this.zoomStart();
    }

    // this.gesture.off('tap', this.e.ZoomIn);
    // this.gesture.off('tap', this.e.ZoomOut);
    // this.gesture.on('tap', this.e.ZoomOut);

    let dragElId = this.store.getKV('dragId');
    let dragEl = document.getElementById(dragElId);
    dragEl.style.transformOrigin = 'center';

    let currentFactor = this.store.getKV('scaleFactor');
    let factor = this.e.prevValue(DocModuler.zoomFactors, currentFactor);
    this.store.setKV('scaleFactor', factor);
    this.gesture.zoom(factor, 0, 0);
  }

  /**
   * 普通移动
   *
   * @memberof ZoomApi
   */
  zoomMove() {
    if (!this.startZoomMode) {
      this.zoomStart();
    }

    this.gesture.off('tap', this.e.ZoomIn);
    this.gesture.off('tap', this.e.ZoomOut);
  }

  /**
   * 还原
   *
   * @memberof DocModuler
   */
  zoomReset() {
    if (!this.startZoomMode) {
      this.zoomStart();
    }

    let scaleFactor = 1;
    this.store.setKV('scaleFactor', scaleFactor);

    if (this.container.type === ContainerType.DOCUMENT) {
      this.container.operateDocument(OperateDocumentEnum.Scale, scaleFactor, 0, 0);
    }

    this.container.operateDoodle(OperateBoardEnum.Scale, scaleFactor, 0, 0);

    this.gesture.reset();
    this.gesture.off('tap', this.e.ZoomIn);
    this.gesture.off('tap', this.e.ZoomOut);
  }

  /**
   * 开启缩放模式
   *
   * @memberof ZoomApi
   */
  zoomStart() {
    // 记录此时画笔类型信息
    this.doodleType = this.container.getDoodoleCurrentId();
    // 取消canvas容器的鼠标行为
    this.container.editable = false;
    this.container.operateDoodle(OperateBoardEnum.SetGraphic, -1);

    // 设置手势
    let dragElId = this.store.getKV('dragId');
    let dragEl = document.getElementById(dragElId);

    if (this.gesture) {
      this.gesture.destroy();
      this.gesture.install(dragEl);
      this.gesture.addMouseWheel(dragEl);
    }

    this.startZoomMode = true;
  }

  /**
   * 结束缩放模式
   *
   * @memberof ZoomApi
   */
  zoomEnd(permission) {
    if (!this.startZoomMode) return;
    // 取消手势行为
    if (this.gesture) {
      // this.gesture.reset()
      this.gesture.destroy();
    }

    // 根据用户角色增加鼠标行为
    const { editable, pageable, cacheable, zoomable } = permission;
    this.container.editable = editable;
    const graphic = this.doodleType || -1;
    this.container.operateDoodle(OperateBoardEnum.SetGraphic, graphic);

    this.startZoomMode = false;
    this.doodleType = null;
  }
}
